/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BrandEdgedCredentialDetailedDto } from './BrandEdgedCredentialDetailedDto';
import {
    BrandEdgedCredentialDetailedDtoFromJSON,
    BrandEdgedCredentialDetailedDtoFromJSONTyped,
    BrandEdgedCredentialDetailedDtoToJSON,
} from './BrandEdgedCredentialDetailedDto';
import type { CampaignEdgedCredentialDetailedDto } from './CampaignEdgedCredentialDetailedDto';
import {
    CampaignEdgedCredentialDetailedDtoFromJSON,
    CampaignEdgedCredentialDetailedDtoFromJSONTyped,
    CampaignEdgedCredentialDetailedDtoToJSON,
} from './CampaignEdgedCredentialDetailedDto';
import type { EdgedCredentialDetailedDto } from './EdgedCredentialDetailedDto';
import {
    EdgedCredentialDetailedDtoFromJSON,
    EdgedCredentialDetailedDtoFromJSONTyped,
    EdgedCredentialDetailedDtoToJSON,
} from './EdgedCredentialDetailedDto';
import type { TNAllocationEdgedCredentialDetailedDto } from './TNAllocationEdgedCredentialDetailedDto';
import {
    TNAllocationEdgedCredentialDetailedDtoFromJSON,
    TNAllocationEdgedCredentialDetailedDtoFromJSONTyped,
    TNAllocationEdgedCredentialDetailedDtoToJSON,
} from './TNAllocationEdgedCredentialDetailedDto';

/**
 * 
 * @export
 * @interface DossierEdgedDetailsResponseDto
 */
export interface DossierEdgedDetailsResponseDto {
    /**
     * Self-Addressing Identifier. Primary credential id
     * @type {string}
     * @memberof DossierEdgedDetailsResponseDto
     */
    dossierSaid?: string;
    /**
     * 
     * @type {EdgedCredentialDetailedDto}
     * @memberof DossierEdgedDetailsResponseDto
     */
    dossierCred?: EdgedCredentialDetailedDto;
    /**
     * 
     * @type {EdgedCredentialDetailedDto}
     * @memberof DossierEdgedDetailsResponseDto
     */
    orgIdentityCred?: EdgedCredentialDetailedDto;
    /**
     * 
     * @type {EdgedCredentialDetailedDto}
     * @memberof DossierEdgedDetailsResponseDto
     */
    rangeCred?: EdgedCredentialDetailedDto;
    /**
     * 
     * @type {TNAllocationEdgedCredentialDetailedDto}
     * @memberof DossierEdgedDetailsResponseDto
     */
    tnAllocCred?: TNAllocationEdgedCredentialDetailedDto;
    /**
     * 
     * @type {EdgedCredentialDetailedDto}
     * @memberof DossierEdgedDetailsResponseDto
     */
    delegatedSignerCred?: EdgedCredentialDetailedDto;
    /**
     * 
     * @type {BrandEdgedCredentialDetailedDto}
     * @memberof DossierEdgedDetailsResponseDto
     */
    brandCred?: BrandEdgedCredentialDetailedDto;
    /**
     * 
     * @type {CampaignEdgedCredentialDetailedDto}
     * @memberof DossierEdgedDetailsResponseDto
     */
    campaignCred?: CampaignEdgedCredentialDetailedDto;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof DossierEdgedDetailsResponseDto
     */
    credentialsProof?: { [key: string]: string; };
}


/**
 * @export
 */
export const DossierEdgedDetailsResponseDtoCredentialsProofEnum = {
    Valid: 'VALID',
    Expired: 'EXPIRED',
    Missing: 'MISSING',
    Revoked: 'REVOKED'
} as const;
export type DossierEdgedDetailsResponseDtoCredentialsProofEnum = typeof DossierEdgedDetailsResponseDtoCredentialsProofEnum[keyof typeof DossierEdgedDetailsResponseDtoCredentialsProofEnum];


/**
 * Check if a given object implements the DossierEdgedDetailsResponseDto interface.
 */
export function instanceOfDossierEdgedDetailsResponseDto(value: object): boolean {
    return true;
}

export function DossierEdgedDetailsResponseDtoFromJSON(json: any): DossierEdgedDetailsResponseDto {
    return DossierEdgedDetailsResponseDtoFromJSONTyped(json, false);
}

export function DossierEdgedDetailsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DossierEdgedDetailsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'dossierSaid': json['dossierSaid'] == null ? undefined : json['dossierSaid'],
        'dossierCred': json['dossierCred'] == null ? undefined : EdgedCredentialDetailedDtoFromJSON(json['dossierCred']),
        'orgIdentityCred': json['orgIdentityCred'] == null ? undefined : EdgedCredentialDetailedDtoFromJSON(json['orgIdentityCred']),
        'rangeCred': json['rangeCred'] == null ? undefined : EdgedCredentialDetailedDtoFromJSON(json['rangeCred']),
        'tnAllocCred': json['tnAllocCred'] == null ? undefined : TNAllocationEdgedCredentialDetailedDtoFromJSON(json['tnAllocCred']),
        'delegatedSignerCred': json['delegatedSignerCred'] == null ? undefined : EdgedCredentialDetailedDtoFromJSON(json['delegatedSignerCred']),
        'brandCred': json['brandCred'] == null ? undefined : BrandEdgedCredentialDetailedDtoFromJSON(json['brandCred']),
        'campaignCred': json['campaignCred'] == null ? undefined : CampaignEdgedCredentialDetailedDtoFromJSON(json['campaignCred']),
        'credentialsProof': json['credentialsProof'] == null ? undefined : json['credentialsProof'],
    };
}

export function DossierEdgedDetailsResponseDtoToJSON(value?: DossierEdgedDetailsResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dossierSaid': value['dossierSaid'],
        'dossierCred': EdgedCredentialDetailedDtoToJSON(value['dossierCred']),
        'orgIdentityCred': EdgedCredentialDetailedDtoToJSON(value['orgIdentityCred']),
        'rangeCred': EdgedCredentialDetailedDtoToJSON(value['rangeCred']),
        'tnAllocCred': TNAllocationEdgedCredentialDetailedDtoToJSON(value['tnAllocCred']),
        'delegatedSignerCred': EdgedCredentialDetailedDtoToJSON(value['delegatedSignerCred']),
        'brandCred': BrandEdgedCredentialDetailedDtoToJSON(value['brandCred']),
        'campaignCred': CampaignEdgedCredentialDetailedDtoToJSON(value['campaignCred']),
        'credentialsProof': value['credentialsProof'],
    };
}

